'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _languages = require('constants/languages');

var _languages2 = _interopRequireDefault(_languages);

var _currencyFormats = require('constants/currencyFormats');

var _currencyFormats2 = _interopRequireDefault(_currencyFormats);

var _timeFormats = require('constants/timeFormats');

var _timeFormats2 = _interopRequireDefault(_timeFormats);

var _components = require('components');

var _containers = require('containers');

var _modals = require('redux/modules/modals');

var _rules = require('redux/modules/rules');

var _modals2 = require('constants/modals');

var _templates = require('redux/modules/templates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Settings = exports.Settings = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Settings, _Component);

  function Settings(props) {
    (0, _classCallCheck3.default)(this, Settings);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Settings.__proto__ || (0, _getPrototypeOf2.default)(Settings)).call(this, props));

    _this._openWindow = function () {
      var _this$props = _this.props,
          getRules = _this$props.getRules,
          codedToken = _this$props.codedToken,
          sendRules = _this$props.sendRules,
          id = _this$props.id;


      if (getRules && typeof getRules === 'function') {
        getRules(id, codedToken);
      }

      _this.props.showModal && _this.props.showModal(_modals2.RULES, {
        body: _react2.default.createElement(_containers.RulesModal, null),
        onCancel: function onCancel() {
          return _this.props.hideModal(_modals2.RULES);
        },
        onConfirm: function onConfirm() {
          _this.props.hideModal(_modals2.RULES);
          sendRules(codedToken);
        }
      });
    };

    _this._changeProperty = function (property, value) {
      var changeProperty = _this.props.changeProperty;


      if (typeof changeProperty === 'function') {
        changeProperty(property, value, _this.props[property]);
      }
    };

    _this._onChangeProperty = function (event) {
      var target = event.target;
      _this._changeProperty(target.name, target.value);
    };

    _this.handleAlignmentChange = _this.handleAlignmentChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Settings, [{
    key: 'handleAlignmentChange',
    value: function handleAlignmentChange(e) {
      var changeProperty = this.props.changeProperty;

      changeProperty('logoAlignment', e.target.value);
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return options.map(function (option) {
        return _react2.default.createElement(
          'option',
          { key: option.key, value: option.value },
          option.description
        );
      });
    }
  }, {
    key: '_renderLanguagePicker',
    value: function _renderLanguagePicker() {
      var language = this.props.language;


      return _react2.default.createElement(
        _components.EnterpriseDropDown,
        {
          name: 'language',
          value: language,
          fill: true,
          onChange: this._onChangeProperty
        },
        this._renderOptions(_languages2.default)
      );
    }
  }, {
    key: '_rendercurrencyFormatPicker',
    value: function _rendercurrencyFormatPicker() {
      var currencyFormat = this.props.currencyFormat;


      return _react2.default.createElement(
        _components.EnterpriseDropDown,
        {
          name: 'currencyFormat',
          value: currencyFormat,
          fill: true,
          onChange: this._onChangeProperty
        },
        this._renderOptions(_currencyFormats2.default)
      );
    }
  }, {
    key: '_renderTimeFormatPicker',
    value: function _renderTimeFormatPicker() {
      var timeFormat = this.props.timeFormat;


      return _react2.default.createElement(
        _components.EnterpriseDropDown,
        {
          name: 'timeFormat',
          value: timeFormat,
          fill: true,
          onChange: this._onChangeProperty
        },
        this._renderOptions(_timeFormats2.default)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          name = _props.name,
          markingId = _props.markingId,
          description = _props.description,
          subject = _props.subject,
          logo = _props.logo,
          logoAlignment = _props.logoAlignment;

      var styles = require('./Settings.scss');
      var Title = _react2.default.createElement(
        'div',
        { className: styles.rootItemTitle },
        _react2.default.createElement(_components.EnterpriseIcons.Config, { fill: 'white', width: 20, height: 20, className: styles.rootItemTitleIcon }),
        _react2.default.createElement(
          'span',
          { className: styles.rootItemTitleLabel },
          'SETTINGS'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.rootItemTitleExpanderIndicator },
          '\u25BC'
        )
      );

      return _react2.default.createElement(
        _components.EnterpriseAccordion,
        { className: (0, _classnames2.default)(className, styles.root), activeItems: [] },
        _react2.default.createElement(
          _components.EnterpriseAccordion.Item,
          {
            className: styles.rootItem,
            expandedClassName: styles['rootItem--expanded'],
            bodyClassName: styles.rootItemBody,
            bodyWrapperClassName: styles.rootItemBodyWrapper,
            title: Title,
            overflowWhenExpanded: 'auto',
            maxHeightWhenExpanded: 'calc(100% - 37px)',
            uuid: 'template-settings-accordion-item'
          },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            null,
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, sm: 9 },
              _react2.default.createElement(
                'div',
                { className: styles.nameDescriptionSubjectWrapper },
                _react2.default.createElement(
                  _components.EnterpriseGrid.Row,
                  null,
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'templateName' },
                      'TEMPLATE NAME'
                    ),
                    _react2.default.createElement(_components.EnterpriseInput, {
                      id: 'templateName',
                      name: 'name',
                      placeholder: 'Template Name',
                      type: 'text',
                      fill: true,
                      value: name || '',
                      onChange: this._onChangeProperty
                    })
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'markingId' },
                      'MARKING ID'
                    ),
                    _react2.default.createElement(_components.EnterpriseInput, {
                      id: 'markingId',
                      name: 'markingId',
                      placeholder: 'Marking Id',
                      type: 'text',
                      fill: true,
                      value: markingId || '',
                      onChange: this._onChangeProperty
                    })
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'templateName' },
                      'TEMPLATE DESCRIPTION'
                    ),
                    _react2.default.createElement(_components.EnterpriseInput, {
                      id: 'templateDescription',
                      name: 'description',
                      placeholder: 'Template Description',
                      type: 'text',
                      fill: true,
                      value: description || '',
                      onChange: this._onChangeProperty
                    })
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'subject' },
                      'Email Subject'
                    ),
                    _react2.default.createElement(_components.EnterpriseInput, {
                      id: 'subject',
                      name: 'subject',
                      placeholder: 'Subject',
                      type: 'text',
                      fill: true,
                      value: subject || '',
                      onChange: this._onChangeProperty
                    })
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'logo' },
                      'Logo URL'
                    ),
                    _react2.default.createElement(_components.EnterpriseInput, {
                      id: 'logo',
                      name: 'logo',
                      placeholder: 'Image URL',
                      type: 'text',
                      fill: true,
                      value: logo || '',
                      onChange: this._onChangeProperty
                    }),
                    _react2.default.createElement(
                      'div',
                      null,
                      'Logo Alignment'
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_components.EnterpriseRadioButton, {
                        checked: logoAlignment === 'left',
                        name: 'imageAlignment',
                        onChange: this.handleAlignmentChange,
                        label: 'Left',
                        value: 'left'
                      }),
                      _react2.default.createElement('div', { 'data-separator': true, style: { display: 'inline-block', marginLeft: '15px' } }),
                      _react2.default.createElement(_components.EnterpriseRadioButton, {
                        checked: logoAlignment === 'right',
                        name: 'imageAlignment',
                        onChange: this.handleAlignmentChange,
                        label: 'Right',
                        value: 'right'
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { xs: 12, sm: 3 },
              _react2.default.createElement(
                'div',
                { className: styles.laguageCurrencyTimeWrapper },
                _react2.default.createElement(
                  _components.EnterpriseGrid.Row,
                  null,
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'language' },
                      'LANGUAGE'
                    ),
                    this._renderLanguagePicker()
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'currencyFormat' },
                      'CURRENCY FORMAT'
                    ),
                    this._rendercurrencyFormatPicker()
                  ),
                  _react2.default.createElement(
                    _components.EnterpriseGrid.Col,
                    { className: (0, _classnames2.default)(styles.fieldWrapper), xs: 12 },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'timeFormat' },
                      'TIME FORMAT'
                    ),
                    this._renderTimeFormatPicker()
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(styles.rulesField) },
                    _react2.default.createElement(
                      'div',
                      { className: (0, _classnames2.default)(styles.rulesFieldText) },
                      'Rules Configuration'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: (0, _classnames2.default)(styles.rulesFieldIcon), onClick: this._openWindow },
                      _react2.default.createElement(_components.EnterpriseIcons.Config, { fill: '#005d8c', width: 30, height: 30, className: styles.rulesFieldIcon })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Settings;
}(_react.Component), _class.propTypes = {
  name: _react.PropTypes.string,
  markingId: _react.PropTypes.string,
  description: _react.PropTypes.string,
  subject: _react.PropTypes.string,
  logo: _react.PropTypes.string,
  language: _react.PropTypes.string,
  currencyFormat: _react.PropTypes.string,
  timeFormat: _react.PropTypes.string,
  codedToken: _react.PropTypes.string,

  changeProperty: _react.PropTypes.func,
  showModal: _react.PropTypes.func,
  hideModal: _react.PropTypes.func,
  getRules: _react.PropTypes.func,
  sendRules: _react.PropTypes.func,

  className: _react.PropTypes.string
}, _class.defaultProps = {
  language: _languages.DEFAULT.value,
  currencyFormat: _currencyFormats.DEFAULT.value,
  timeFormat: _timeFormats.DEFAULT.value
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  var template = state.templateApplication.templates.currentTemplate || {};
  var name = template.name,
      markingId = template.markingId,
      description = template.description,
      subject = template.subject,
      logo = template.logo,
      language = template.language,
      currencyFormat = template.currencyFormat,
      timeFormat = template.timeFormat,
      logoAlignment = template.logoAlignment,
      id = template.id;


  return {
    name: name,
    markingId: markingId,
    description: description,
    subject: subject,
    logo: logo,
    language: language,
    currencyFormat: currencyFormat,
    timeFormat: timeFormat,
    logoAlignment: logoAlignment,
    codedToken: state.auth.codedToken,
    id: id
  };
};

var mdtp = {
  changeProperty: _templates.changeProperty,
  showModal: _modals.show,
  hideModal: _modals.hide,
  readRules: _rules.getRules,
  getRules: _rules.getRules.base,
  sendRules: _rules.sendRules.base
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mdtp)(Settings);


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplateEditor/Settings/Settings.jsx
// module id = 1644
// module chunks = 0